import { render, staticRenderFns } from "./resourceBase.vue?vue&type=template&id=b930174e&scoped=true"
import script from "./resourceBase.vue?vue&type=script&lang=js"
export * from "./resourceBase.vue?vue&type=script&lang=js"
import style0 from "./resourceBase.vue?vue&type=style&index=0&id=b930174e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b930174e",
  null
  
)

export default component.exports